import { Reader, Writer } from "protobufjs/minimal";
import type {
  ProductImageTypes,
  ProductImage,
  ProductImageTracker,
} from "../../aysa_api/models/product_images.types";

export const decodeProductImageTypes = (reader: Reader): ProductImageTypes => {
  switch (reader.int32()) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    default:
      return 0;
  }
};

export const encodeProductImageTypes = (
  writer: Writer,
  value: ProductImageTypes
): Writer => {
  return writer.int32(value);
};

export const createBaseProductImage = (): ProductImage => {
  return {
    src: "",
    description: "",
    isEnclosed: false,
  };
};

export const decodeProductImage = (
  reader: Reader,
  length: number
): ProductImage => {
  const end = reader.pos + length;
  const message = createBaseProductImage();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.src = reader.string();

        break;
      case 2:
        message.description = reader.string();

        break;
      case 3:
        message.isEnclosed = reader.bool();

        break;
      case 4:
        message.tracker = decodeProductImageTracker(reader, reader.uint32());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductImage = (
  writer: Writer,
  message: ProductImage
): Writer => {
  writer.uint32(10).string(message.src);
  writer.uint32(18).string(message.description);
  writer.uint32(24).bool(message.isEnclosed);
  if (message.tracker !== undefined) {
    encodeProductImageTracker(
      writer.uint32(34).fork(),
      message.tracker
    ).ldelim();
  }

  return writer;
};

export const createBaseProductImageTracker = (): ProductImageTracker => {
  return {
    type: "",
  };
};

export const decodeProductImageTracker = (
  reader: Reader,
  length: number
): ProductImageTracker => {
  const end = reader.pos + length;
  const message = createBaseProductImageTracker();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.type = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeProductImageTracker = (
  writer: Writer,
  message: ProductImageTracker
): Writer => {
  writer.uint32(10).string(message.type);

  return writer;
};
